import InfiniteScroll from 'react-infinite-scroll-component';

import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';

import { getCommunityScopeOptions } from 'shared/constants';
import { useTransl } from 'shared/lib/i18n';

import CommunityPostItemContainer from './CommunityPostItemContainer';

import RadioGroup from '../../Shared/RadioGroup';
import { PostSkeleton } from '../../Shared/skeletons';

const CommunityPostsListComponent = (props) => {
  const { t } = useTransl();
  const {
    loadNextPosts,
    nextPosts,
    isLoading,
    postsList,
    communityType,
    setCommunityType,
  } = props;

  return (
    <>
      <RadioGroup
        options={getCommunityScopeOptions()}
        currentValue={communityType}
        setCurrentValue={setCommunityType}
      />

      {isLoading &&
        !postsList?.length &&
        Array.from({ length: 5 }, (_, i) => i).map((i) => (
          <PostSkeleton key={i} />
        ))}

      <InfiniteScroll
        dataLength={postsList.length}
        next={() => loadNextPosts()}
        hasMore={nextPosts}
        loader={<PostSkeleton />}
        endMessage={
          postsList.length === 0 && isLoading ? (
            <PostSkeleton />
          ) : postsList.length === 0 ? (
            <Typography
              component="div"
              align="center"
              sx={{ marginTop: '2rem' }}
            >
              {t('community.noPosts')}
            </Typography>
          ) : (
            <span>
              <hr />
            </span>
          )
        }
      >
        <Box display="flex" flexDirection="column">
          {postsList?.map((post) => (
            <CommunityPostItemContainer key={post?.id} post={post} />
          ))}
        </Box>
      </InfiniteScroll>
    </>
  );
};
CommunityPostsListComponent.defaultProps = {
  nextPosts: null,
};

CommunityPostsListComponent.propTypes = {
  postsList: PropTypes.instanceOf(Object).isRequired,
  loadNextPosts: PropTypes.func.isRequired,
  nextPosts: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool.isRequired,
  setCommunityType: PropTypes.func.isRequired,
  communityType: PropTypes.string.isRequired,
};

export default CommunityPostsListComponent;
